import React, { Profiler } from "react";
import AppShell from "../components/elements/AppShell/index.js";
import NotFoundInner from "../components/elements/NotFound/index.js";
import Frame from "../components/elements/Frame/index.js";
import { PageHeader } from "./Search.js";
import { useStore } from "../store/index.js";
import useClientMetrics from "../hooks/useClientMetrics.js";
const NotFound = function () {
    const store = useStore();
    const { trackRenderTime } = useClientMetrics();
    const { searchSegments } = store.search;
    return (React.createElement(Profiler, { id: "screen", onRender: trackRenderTime },
        React.createElement(PageHeader, { segments: searchSegments }),
        React.createElement(AppShell, null,
            React.createElement(Frame, { mr: 4, mb: 4, ml: 4 },
                React.createElement(NotFoundInner, null)))));
};
export default NotFound;
